module.exports = __webpack_public_path__ + "static/media/achievement-placeholder-pink.2d952565.svg";